export const calculateInstallments = (amount, numberOfPayments) => {
  //this calc is also used  on server iotUtills file on mApp and client for actual same installment calculation, so keeping it simple and consistent across all platforms.
  if (typeof amount !== 'number' || typeof numberOfPayments !== 'number') {
    return [];
  }
  if (amount <= 0 || numberOfPayments <= 0) {
    return [];
    // throw new Error('amount and numberOfPayments must be greater than 0');
  }
  if (numberOfPayments === 1) {
    return [amount];
  }
  const basePayment = Math.floor(amount / numberOfPayments);
  const numberOfPaymentsMinusLastPayment = numberOfPayments - 1;
  let payments = [];
  for (let index = 0; index < numberOfPaymentsMinusLastPayment; index++) {
    payments.push(basePayment);
  }
  let lastPayment = amount - basePayment * numberOfPaymentsMinusLastPayment;
  lastPayment = parseFloat(lastPayment.toFixed(2));
  payments.push(lastPayment);
  return payments;
};

export const paymentsDescriptionByPaymentArray = (payments, currencySymbol) => {
  if (!Array.isArray(payments) || payments.length === 0) {
    return '';
  }

  const symbol = currencySymbol;

  // Group payments by amount and track order of first appearance
  const paymentGroups = {};
  const uniqueAmounts = [];

  payments.forEach((payment) => {
    if (!paymentGroups[payment]) {
      paymentGroups[payment] = 0;
      uniqueAmounts.push(payment);
    }
    paymentGroups[payment]++;
  });

  // Build description parts for each unique amount
  const parts = uniqueAmounts.map((amount) => {
    const count = paymentGroups[amount];
    if (count === 1) {
      return `${count} X ${symbol}${amount}`;
    } else {
      return `${count} X ${symbol}${amount}`;
    }
  });

  return parts.join(' + ');
};

export const convertPaymentMethodToText = (paymentMethodId) => {
  let paymentMethodText;
  switch (paymentMethodId) {
    case 1:
      paymentMethodText = 'cashless sales';
      break;
    case 2:
      paymentMethodText = 'credit card';
      break;
    case 3:
      paymentMethodText = 'ACH';
      break;
    default:
      paymentMethodText = '';
  }
  return paymentMethodText;
};

export const convertFromNumberToPlannedCycle = (cycle) => {
  let cycleText;
  switch (cycle) {
    case 1:
      cycleText = 'daily';
      break;
    case 7:
      cycleText = 'weekly';
      break;
    case 14:
      cycleText = 'bi-weekly';
      break;
    case 28 || 30 || 31:
      cycleText = 'monthly';
      break;
    default:
      cycleText = '';
  }
  return cycleText;
};
